const moment = require('moment');
const defaultState = {
    fp: [],
    fpDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersFP:[],
    fpHist:[]
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_FP_FULFILLED': {       
        let arrayMain=[];
        let newItem = {};
        
        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
                newItem = {};
                newItem = element;//limpa para criar um novo
                newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');

                //fazer set de state destes valores como auxiliares para criar valdiações
                arrayMain.push(newItem);
            });       
        }else{
            console.log('FETCH_FP_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        
        return {
          ...state,
          fp: arrayMain,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_FP_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_FP_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_FP_DETAIL_FULFILLED': {
    
        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        
        return {
          ...state,
          fpDetail: action.payload.data[0],
          fp: state.fp.map(item => item.ID === id ? {...item, STATUS: status} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_FP_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          fpDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_FP_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_FP': {      
        return {
          ...state,
          lastFiltersFP: action.payload
        }
      }

      case 'FETCH_FP_HISTORY_FULFILLED': {
        return {
          ...state,
          fpHist: action.payload.data,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_FP_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_FP_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }       

      case 'EDIT_FP_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        return {
            ...state,
            fp: state.fp.map(item => item.ID === id 
                ? auxEditedRecord 
                : item
            )
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/fp-reducer.js